import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { CREATE_STUDENT_TALK, GET_ALL_UNIVERSITY, GET_STUDENT_TALK_CAT, fetchData } from "../../components/Service";
import { toast } from "react-toastify";
import { Context } from "../../components/Context";
import Select from "react-select";
import { PhoneNumberUtil } from "google-libphonenumber";
import { PhoneInput, defaultCountries, parseCountry } from "react-international-phone";
import "react-international-phone/style.css";
import {useNavigate,} from "../../../node_modules/react-router-dom/dist/index";


const phoneUtil = PhoneNumberUtil.getInstance();

const CreateStudentTalk = () => {
	const navigate = useNavigate();
	const [context] = useContext(Context);
	const [cat, setCat] = useState([]);
	const [uni, setUni] = useState([]);
	const [selectedCat, setSelectedCat] = useState(null);
	const [selectedUni, setSelectedUni] = useState(null);
	const [defaultPhoneCountry] = useState("us");
	const [fullPhone, setFullPhone] = useState("");

	const countriesList = context?.countryList?.map((item) => item?.code?.toLowerCase()) || [];

	const countries = defaultCountries.filter((country) => {
		const { iso2 } = parseCountry(country);
		return countriesList.includes(iso2);
	});

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		setValue,
		setError,
		clearErrors,
		reset,
		trigger,
	} = useForm({ mode: "onChange" });

	const isPhoneValid = (phone, country_code) => {
		try {
			// if (!phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phone))) {
			// 	setError("mobile", { message: "Phone is invalid." });
			// 	setValue("mobile", "");
			// } else {
			// 	clearErrors("mobile");
			// 	setValue("mobile", phone);
			// }

			const onlyPhone = phone.replace(`+${country_code}`, "").trim();
			if (onlyPhone) {
				setValue("mobile", phone, { shouldValidate: true });
				clearErrors("mobile");
			} else {
				setValue("mobile", "");
				// setError("mobile", { message: "Mobile number is required." });
			}
		} catch (error) {
			return false;
		}
	};

	const getCategory = () => {
		fetchData(GET_STUDENT_TALK_CAT, "GET", "", false, false, (res) => {
			if (res.status) {
				setCat(res?.data);
			} else {
				setCat([]);
			}
		});
	};

	const getUniversity = () => {
		let payload = {
			country_id: context?.countryId,
			state_id: context?.stateId,
		};
		fetchData(GET_ALL_UNIVERSITY, "POST", payload, false, false, (res) => {
			if (res.status) {
				setUni(res?.data);
			} else {
				setUni([]);
			}
		});
	};

	const createData = (data) => {
		data = {
			user_id: context?.user?.user_id,
			country_id: context?.countryId,
			state_id: context?.stateId,
			other_details: "",
			...data,
		};

		fetchData(CREATE_STUDENT_TALK, "POST", data, true, false, (res) => {
			if (res.status) {
				toast.success("Student talk created successfully.");
				navigate(`/profile?tab=ads`);
				reset();

				window.$("#createStudentTalkModal").modal("hide");
			} else {
				toast.error("Unable to create student talk.");
			}
		});
	};

	useEffect(() => {
		getCategory();
		getUniversity();
	}, [context?.stateId]);

	useEffect(() => {
		setValue("email_id", context?.user?.email ?? "");
		setValue("address", context?.user?.address ?? "");
		setValue("mobile", context?.user?.mobile ?? "");
		setFullPhone(context?.user?.mobile ?? "");
	}, [context?.user]);
	
	useEffect(() => {
		const modalEl = document.getElementById("createStudentTalkModal");
	
		const handleShow = () => {
			setValue("email_id", context?.user?.email ?? "");
			setValue("address", context?.user?.address ?? "");
			setValue("mobile", context?.user?.mobile ?? "");
			setFullPhone(context?.user?.mobile ?? "");
		};
	
		if (modalEl) {
			modalEl.addEventListener("show.bs.modal", handleShow);
		}
	
		return () => {
			if (modalEl) {
				modalEl.removeEventListener("show.bs.modal", handleShow);
			}
		};
	}, [context?.user]);
	
	return (
		<div
			className="modal fade pe-0"
			id="createStudentTalkModal"
			data-bs-backdrop="static"
			data-bs-keyboard="false"
			tabindex="-1"
			aria-labelledby="staticBackdropLabel"
			aria-hidden="true"
		>
			<div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
				<div className="modal-content">
					<button
						className="btn-close"
						type="button"
						data-bs-dismiss="modal"
						aria-label="Close"
						onClick={() => {
							reset();
							setSelectedCat(null);
							setValue("category_id", "");
							setSelectedUni(null);
							setValue("university_id", "");
						}}
					></button>
					<div className="modal-header d-block text-center border-bottom-0">
						<h5 className="text-brand-1 text-capitalize">Create Student Talk</h5>
					</div>
					<div className="modal-body px-4 px-xl-5 py-3">
						<form className="login-register text-start mt-20 pb-30 needs-validation" onSubmit={handleSubmit(createData)}>
							<div className="row">
								<div className="col-sm-6 col-md-4 col-lg-4 mb-2">
									<label>
										Title <span className="text-danger">*</span>
									</label>
									<input
										className={`form-control bg-transparent ${errors.title && "is-invalid"}`}
										placeholder="Title"
										maxLength={150}
										{...register("title", {
											required: { value: true, message: "Title is required." },
										})}
									/>
									{errors.title && <div class="invalid-feedback">{errors.title.message}</div>}
								</div>
								<div className="col-sm-6 col-md-4 col-lg-4 mb-2">
									<label>
										Email 
										<span className="text-danger">*</span>
									</label>
									<input
										className={`form-control bg-transparent ${errors.email_id && "is-invalid"}`}
										placeholder="Email"
										type="email"
										maxLength={120}										
										{...register("email_id", {
											required: { value: true, message: "Email is required." },
											pattern: { value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, message: "Email is invalid." },
										})}
										readOnly 
									/>
									{errors.email_id && <div class="invalid-feedback">{errors.email_id.message}</div>}
								</div>
								<div className="col-sm-6 col-md-4 col-lg-4 mb-2">
									<label>
										Mobile No 
										{/* <span className="text-danger">*</span> */}
									</label>

									<PhoneInput
										key={defaultPhoneCountry}
										defaultCountry={defaultPhoneCountry}
										countries={countries}
										forceDialCode={true}
										value={fullPhone}
										hideDropdown={false}
										disableCountryGuess={true}
										onChange={(phone, country) => {
											isPhoneValid(phone, country.country.dialCode);
											setFullPhone(phone);
											setValue("country_code", `+${country.country.dialCode}` || "+1");
										}}
										className={`form-control bg-transparent p-0 ${errors.mobile ? "is-invalid" : ""}`}
									/>
									<input
										type="hidden"
										{...register("mobile", {
											// required: "Mobile number is invalid.",
										})}
									/>
									{errors.mobile && <div class="invalid-feedback">{errors.mobile.message}</div>}
								</div>
								<div className="col-sm-6 col-md-4 col-lg-4 mb-2">
									<label>
										University 
										<span className="text-danger">*</span>
									</label>

									<Select
										{...register("university_id", {
											required: { value: true, message: "Select an university." },
										})}
										options={
											[...uni]
												.sort((a, b) => a.name.localeCompare(b.name))
											.map((item) => ({
											label: item.name,
											value: item.id,
										}))}
										value={selectedUni}
										onChange={(selected) => {
											setSelectedUni(selected);
											setValue("university_id", selected ? selected.value : "");
											trigger("university_id");
										}}
										placeholder="Select an university"
										className={`selectpicker p-0 ${errors.university_id && "is-invalid bdr-red"}`}
										classNamePrefix="react-select"
									/>
									{errors.university_id && <div class="invalid-feedback d-block">{errors.university_id.message}</div>}
								</div>
								<div className="col-sm-6 col-md-4 col-lg-4 mb-2">
									<label>
										Category <span className="text-danger">*</span>
									</label>

									<Select
										{...register("category_id", {
											required: { value: true, message: "Select a category." },
										})}
										options={cat?.map((item) => ({
											label: item.name,
											value: item.id,
										}))}
										value={selectedCat}
										onChange={(selected) => {
											setSelectedCat(selected);
											setValue("category_id", selected ? selected.value : "");
											trigger("category_id");
										}}
										placeholder="Select a category"
										className={`selectpicker p-0 ${errors.category_id && "is-invalid bdr-red"}`}
										classNamePrefix="react-select"
									/>

									{errors.category_id && <div class="invalid-feedback d-block">{errors.category_id.message}</div>}
								</div>
								<div className="col-12 mb-2">
									<label>
										Address 
										<span className="text-danger">*</span>
									</label>
									<input
										class={`form-control ${errors.address && "is-invalid"}`}
										rows="5"
										placeholder="Address"
										{...register("address", {
											required: { value: true, message: "Address is required." },
										})}
									></input>
									{errors.address && <div class="invalid-feedback d-block">{errors.address.message}</div>}
								</div>
								<div className="col-sm-12 col-md-12 col-lg-12 mb-2">
									<label>Message</label>
									<textarea class={`form-control ${errors.message && "is-invalid"}`} rows="5" placeholder="Message" {...register("message")}></textarea>
									{errors.message && <div class="invalid-feedback d-block">{errors.message.message}</div>}
								</div>
								{/* <div className="col-sm-6 col-md-6 col-lg-6 mb-2">
									<label>Other Details</label>
									<textarea class={`form-control ${errors.other_details && "is-invalid"}`} rows="5" placeholder="Other Details" {...register("other_details")}></textarea>
									{errors.other_details && <div class="invalid-feedback d-block">{errors.other_details.message}</div>}
								</div> */}
							</div>
							<div className="modal-footer d-block text-center border-0">
								<button className={`btn btn-default hover-up m-auto`} type="submit" name="Submit">
									Submit
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	);
};

export default CreateStudentTalk;
